import { createUserManager } from 'redux-oidc';

const url =
	window && window.location ? window.location : { protocol: 'https:', hostname: 'bip.identity.pl', origin: '' };

export const OidcConfiguration = {
	redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port
		? `:${window.location.port}`
		: ''}/authentication/callback`,
	post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}`,
	silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port
		? `:${window.location.port}`
		: ''}/authentication/silent_callback`,
	response_type: 'code',
	scope: 'openid profile offline_access asw-api',
	automaticSilentRenew: true,
	loadUserInfo: true,
	revokeAccessTokenOnSignout: true
};

export const userManager = createUserManager(OidcConfiguration);
